import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    BaseEntityResponse,
    UserActivityStatus,
    BaseEntitiesResponse,
    UserLoginParams,
    UserLogin, CredentialInfo
} from "@base/entities/BaseEntities";
import { APIGatewayService } from "../gateway/APIGateway.service";
import { BaseEndpoint } from "@base/endpoint/BaseEndpoint";
import {DataLoadOptions} from "@base/datalayer/DataLoadOptions";

@Injectable()
export class UserActivityEndpoint extends BaseEndpoint
{
    //Constructor
    constructor(api: APIGatewayService) {
        super("UserActivity", api);
    }
    
    public ListActivity(CredentialType: number, options: DataLoadOptions): Observable<BaseEntityResponse<UserActivityStatus>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'ListActivity', {CredentialType: CredentialType, options: options?.GetLoadOptions()});
    }
    
    public ListCredentialsInfo(): Observable<BaseEntitiesResponse<CredentialInfo>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'ListCredentialsInfo');
    }

    public ListLogins(Params: UserLoginParams, options: DataLoadOptions): Observable<BaseEntitiesResponse<UserLogin>> {
        return this.api.ExecutePostAction(this.ControllerName, 'ListLogins', Params, options?.GetLoadOptions());
    }
}
